import OrganizationList from '@/views/ClientManagement/Organization/List.vue'
import OrganizationEdit from '@/views/ClientManagement/Organization/Edit.vue'
import PageIndex from '@/components/Utils/PageIndex.vue'
import LevelUsage from '@/views/Subscribtion/LevelUsage.vue'
import OperatorRecord from '@/views/Subscribtion/OperatorRecord.vue'
import ClientList from '@/views/ClientManagement/Client/List.vue'
import Home from '@/views/Home.vue'
import SystemConfig from '@/views/Setting/SystemConfig.vue'

const private_routes = [
	{
		is_show_sidebar: false,
		name: '首頁',
		path: '/home',
		component: Home,
	},
	{
		feature: 'user_management',
		is_show_sidebar: true,
		icon: "mdi-office-building",
		name: '用戶管理',
		path: '/user_management',
		component: PageIndex,
		children: [
			{
				feature: 'organization',
				is_show_sidebar: true,
				icon: "mdi-office-building",
				path: "/user_management/organization/",
				link: '/user_management/organization/',
				name: "組織列表",
				component:  OrganizationList,
				meta: {
					feature: 'organization',
					breadcrumbs: [
						{
							"text": "用戶管理",
							disabled: true,
						},
						{
							"text": "組織",
							disabled: false,
						},
					],
				}
			},
			{
				feature: 'organization',
				is_show_sidebar: false,
				path: "/user_management/organization/:org_id",
				name: "組織",
				component:  OrganizationEdit,
				meta: {
					breadcrumbs: [
						{
							"text": "用戶管理",
							disabled: true,
						},
						{
							"text": "組織",
							disabled: false,
						},
					],
				}
			},
			{
				feature: 'users',
				is_show_sidebar: true,
				link: "/user_management/users/",
				path: "/user_management/users/",
				name: "用戶",
				component: ClientList,
				meta: {
					feature: 'users',
					breadcrumbs: [
						{
							"text": "用戶管理",
							disabled: true,
						},
						{
							"text": "用戶",
							disabled: false,
						},
					],
				}
				
			}
		],

	},
	{
		feature: 'subscribtion',
		is_show_sidebar: true,
		icon: "mdi-check-decagram-outline",
		name: '訂閱管理',
		path: '/subscribtion',
		component: PageIndex,
		children: [
			{
				feature: 'level_usage',
				is_show_sidebar: true,
				path: "/subscribtion/level_usage",
				link: '/subscribtion/level_usage',
				name: "模組使用數",
				component: LevelUsage,
				meta: {
					feature: 'subscribtion',
					breadcrumbs: [
						{
							"text": "訂閱管理",
							disabled: true,
						},
						{
							"text": "模組使用數",
							disabled: false,
						},
					],
				}
			},
			{
				feature: 'log',
				is_show_sidebar: true,
				path: "/subscribtion/log",
				link: '/subscribtion/log',
				name: "操作紀錄",
				component: OperatorRecord,
				meta: {
					feature: 'log',
					breadcrumbs: [
						{
							"text": "訂閱管理",
							disabled: true,
						},
						{
							"text": "操作紀錄",
							disabled: false,
						},
					],
				}
			}
		]
	},
	{
		feature: 'setting',
		is_show_sidebar: true,
		icon: "mdi-cog-outline",
		name: '設定',
		path: '/setting',
		component: PageIndex,
		children: [
			{
				feature: 'system_config',
				is_show_sidebar: true,
				path: "/setting/system_config",
				link: '/setting/system_config',
				name: "系統設定檔",
				component: SystemConfig,
				meta: {
					breadcrumbs: [
						{
							"text": "設定",
							disabled: true,
						},
						{
							"text": "系統設定檔",
							disabled: false,
						},
					],
				}
			},
			{
				feature: 'guide',
				is_show_sidebar: true,
				path: "/setting/guide",
				link: '/setting/guide',
				name: "導覽管理",
				component: () => import('@/views/Setting/Guide/List.vue'),
				meta: {
					breadcrumbs: [
						{
							"text": "設定",
							disabled: true,
						},
						{
							"text": "導覽管理",
							disabled: false,
						},
					],
				}
			},
			{
				feature: 'guide',
				is_show_sidebar: false,
				path: "/setting/guide/:guide_id",
				name: "導覽編輯",
				component: () => import('@/views/Setting/Guide/Edit.vue'),
				meta: {
					breadcrumbs: [
						{
							"text": "設定",
							disabled: true,
						},
						{
							"text": "導覽管理",
							disabled: false,
							to: '/setting/guide',
						},
						{
							"text": "編輯",
							disabled: false,
						},
					],
				}
			},
		]
	}
]

export default private_routes